import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render DTA contact us page
 */
const DTAContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="dta-contact-us-page-component"
      className="mb-5 font-public-sans leading-[1.4]"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="pt-3 mb-2 text-3xl md:text-5xl lg:text-6xl font-medium font-public-sans"
      />

      <p>
        For submission or more information on Design AI and Tech Award 2026,
        please contact:
      </p>

      <ul className="mb-6">
        <li>Lin Shaomei</li>

        <li>The Business Times</li>

        <li>1000 Toa Payoh North</li>

        <li>Podium Level 3, Singapore 318994</li>
      </ul>

      <p>
        Email:&nbsp;
        <a
          href="mailto:smlin@sph.com.sg"
          className="text-blue-175 hover:text-gray-850 hover:underline"
        >
          smlin@sph.com.sg
        </a>
      </p>
    </div>
  );
};

export default DTAContactUsPage;
